module.exports = __webpack_public_path__ + "static/media/Leccion-10-08-Como-Sentirme-Seguro-con-Dios.e09ae7ff.pdf";